module.exports = __webpack_public_path__ + "img/google19.c3a12c71.jpg";